import { action } from 'typesafe-actions';
import sports from 'app/utils/static/sports';
import { OnBoardingActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */
export const getSports = (): any => action(types.GET_SPORTS_SUCCESS, { sports });

export const updateAdminData = (data): any => action(types.UPDATE_ADMIN_DATA, data);

export const loadGetStarted = (): any => action(types.LOAD_GET_STARTED);

export const resetOnboarding = (): any => action(types.RESET_ONBOARDING);

export const createNewUser = (
  {
    email,
    password,
    fullName,
    mobile,
    invitationId = undefined,
    organisationId = undefined,
  },
  provider = undefined,
): any => action(types.CREATE_NEW_USER_REQUESTED, {
  email,
  password,
  fullName,
  mobile,
  invitationId,
  organisationId,
  provider,
});

export const loginUser = (user): any => action(types.LOGIN_USER_REQUESTED, user);
export const verifyUser = (user, redirectLocation = undefined): any => action(types.VERIFY_USER_REQUESTED, { user, redirectLocation });
export const createBankAccount = (data): any => action(types.CREATE_BANK_ACCOUNT_REQUESTED, data);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  operationPending: (): any => action(types.OPERATION_PENDING),
  operationFinished: (): any => action(types.OPERATION_FINISHED),
  userCreationSuccess: (): any => action(types.USER_CREATION_SUCCESS),
  userCreationFailed: (error): any => action(types.USER_CREATION_FAILED, { backendErrors: error }),
  verificationSuccess: (response): any => action(types.VERIFICATION_SUCCESS, response),
  verificationFailed: (error): any => action(types.VERIFICATION_FAILED, { backendErrors: error }),
  userCreateTeamSuccess: (response): any => action(types.USER_CREATE_TEAM_SUCCESS, response),
  continueToDashboard: (): any => action(types.CONTINUE_TO_DASHBOARD),
  bankAccountCreationFailed: (error): any => action(types.BANK_ACCOUNT_CREATION_FAILED, { backendErrors: error }),
};

export default null;
